(function () {
  const root = document.querySelector('.cl-page-content');
  if (!root) return;
  const offer = root.querySelector('#fw-sales #packages');
  if (!offer) return;
  const ids = root.querySelector('.alv-offer')
    ? {1: 67839558516923, 2: 67839558549691, 3: 67839558582459}
    : {1: 67839603802299, 2: 67839603835067, 3: 67839603867835};

  async function openDrawer() {
    const response = await fetch('/?sections=cart-drawer-section', {credentials:'same-origin'});
    if (!response.ok) throw new Error('Cart drawer refresh failed');
    const sections = await response.json();
    const html = sections['cart-drawer-section'];
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.querySelector('#cart-drawer');
    const current = document.querySelector('#cart-drawer');
    if (!replacement || !current) throw new Error('Cart drawer unavailable');
    current.replaceWith(replacement);
    await customElements.whenDefined('theme-drawer');
    replacement.open();
  }
  async function add(tier, button) {
    const id = ids[tier];
    if (!id) return;
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:1,...(root.querySelector('.alv-offer') ? {selling_plan:160374358203} : {})}]})});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add to cart');
      await openDrawer();
    } catch (error) {
      const status = offer.querySelector('.fw-commerce-error');
      if (status) {status.textContent = error.message; status.hidden = false;}
    } finally { button.disabled = false; }
  }
  offer.querySelectorAll('[data-package]').forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    add(Number(button.dataset.package), button);
  }));
  offer.querySelectorAll('.alv-offer').forEach(box => {
    box.querySelectorAll('.alv-item').forEach(item => {
      const select = () => {
        box.querySelectorAll('.alv-item').forEach(other => {
          const yes = other === item;
          other.classList.toggle('selected',yes);
          other.setAttribute('aria-checked',String(yes));
          other.tabIndex = yes ? 0 : -1;
        });
        const button = box.querySelector('.alv-atc2');
        if (button) {
          button.dataset.tier = item.dataset.t;
          for (const [from,to] of [['.alv-vprice','.alv-atc-p'],['.alv-vcompare','.alv-atc-s']]) {
            const source = item.querySelector(from), target = button.querySelector(to);
            if (source && target) target.textContent = source.textContent.trim();
          }
        }
      };
      item.addEventListener('click',select);
      item.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();select();}});
    });
    const button=box.querySelector('.alv-atc2');
    if(button) button.addEventListener('click',e=>{e.preventDefault();const selected=box.querySelector('.alv-item.selected');add(Number(selected?.dataset.t||button.dataset.tier||2),button);});
  });
})();
